import { APPS } from '../utils/cloudStorage';
import { useAuthStore } from '../store/authStore';
import ExpiringBanner from './ExpiringBanner';
import SubscriptionStatusPanel from './SubscriptionStatusPanel';

const isExpiredStatus = (status) =>
  status === 'EXPIRED' || status === 'EXPIRED_SOFT' || status === 'EXPIRED_HARD';

export default function SubscriptionGuard({
  status,
  daysLeft,
  expiresAtLabel,
  children,
  landing,
  appName,
  appKey,
}) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  if (APPS[appKey]?.premium === false) return isAuthenticated ? children : landing;
  if (status === 'ACTIVE') return children;

  if (status === 'EXPIRING') {
    return (
      <>
        <ExpiringBanner
          days={daysLeft}
          expiresAtLabel={expiresAtLabel}
          appKey={appKey}
          appName={appName}
        />
        {children}
      </>
    );
  }

  if (isExpiredStatus(status)) {
    return (
      <SubscriptionStatusPanel
        status="EXPIRED"
        expiresAtLabel={expiresAtLabel}
        appName={appName}
        appKey={appKey}
      />
    );
  }

  return landing;
}
